import { IHttpRequestConfig } from "@/browser";
import { IMAGES_EXTENSIONS } from "@/consts/fileExtensions";
import { TAttachmentPurpose } from "@/data/attachments";
import { prepareAttachment } from "@/eworkitComponents";

import { uploadFileAws } from "../uploadFileAws";

interface AttachmentProps {
  file?: File;
  type: TAttachmentPurpose;
  maxSizeMb?: number;
}

const uploadBasedOnProps = (
  props: AttachmentProps & { onUploadProgress: (progress: number) => void },
  config: IHttpRequestConfig,
) => {
  const { file, type, onUploadProgress, maxSizeMb } = props;

  if (file) {
    if (maxSizeMb && file.size && file.size / (1024 * 1024) > maxSizeMb) {
      throw { message: `File size exceeded max limit: ${maxSizeMb}`, status: 413, payload: true };
    }

    if (!IMAGES_EXTENSIONS.some(e => e.mimeTypes.some(m => m === file?.type))) {
      throw { message: "Invalid file format.", status: 415, payload: true };
    }

    return uploadFileAws({ file, type, onUploadProgress }, config);
  }

  throw new Error("File should be provided to upload");
};

export const attachmentBuilder = prepareAttachment<AttachmentProps>(uploadBasedOnProps);
